import { render, staticRenderFns } from "./releases_pagination_apollo_client.vue?vue&type=template&id=1095f3fe&"
import script from "./releases_pagination_apollo_client.vue?vue&type=script&lang=js&"
export * from "./releases_pagination_apollo_client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports